<p-toast></p-toast>
<div id="card-style">
  <ng-template #loadingSpinner>
    <p>Loading...</p>
  </ng-template>

  <div *ngIf="roleLoaded">
    <p-card header="Quiz" *ngIf="!isStudent(); else studentView">
      <p-table
        #dt2
        [value]="filteredQuizDetails"
        dataKey="id"
        [rows]="rowLimit"
        [showCurrentPageReport]="true"
        responsiveLayout="stack"
        [breakpoint]="'960px'"
        styleClass="p-datatable-striped p-datatable-gridlines p-datatable-sm"
        [rowsPerPageOptions]="[10, 25, 50]"
        [loading]="loading"
        [paginator]="true"
        editMode="row"
        (rowsChange)="onRowLimitChange($event)"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [globalFilterFields]="['name', 'teacherNamesStr', 'mappedQuizMode', 'totalQuestions']"
        [tableStyle]="{ 'min-width': '50rem' }"
        [(selection)]="selectedQuestion"
        [customSort]="true"
        (sortFunction)="customSort($event)"
      >
        <ng-template pTemplate="caption">
          <div class="flex flex-column md:flex-row md:align-items-center gap-2">
            <button
              type="button"
              class="bg-primary border-primary-500 px-3 py-2 text-base border-1 border-solid border-round cursor-pointer transition-all transition-duration-200 hover:bg-primary-600 hover:border-primary-600 active:bg-primary-700 active:border-primary-700 w-full md:w-auto"
              (click)="createNew()"
            >
              Add New Quiz
            </button>
            <span class="p-input-icon-left w-full md:w-auto md:ml-auto">
              <i class="pi pi-search"></i>
              <input
                pInputText
                type="text"
                placeholder="Search keyword"
                (input)="onGlobalFilter($event)"
                class="w-full md:w-auto"
              />
            </span>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="name">
              Name<p-sortIcon field="name"></p-sortIcon
              ><p-columnFilter type="text" field="name" display="menu" />
            </th>
            <th pSortableColumn="teacherNamesStr">
              Teacher<p-sortIcon field="teacherNamesStr"></p-sortIcon
              ><p-columnFilter type="text" field="teacherNamesStr" display="menu" />
            </th>
            <th pSortableColumn="mappedQuizMode">
              Quiz Mode<p-sortIcon field="mappedQuizMode"></p-sortIcon>
              <p-columnFilter type="text" field="mappedQuizMode" display="menu" />
            </th>
            <th pSortableColumn="totalQuestions">
              Total Questions<p-sortIcon field="totalQuestions"></p-sortIcon
              ><p-columnFilter type="text" field="totalQuestions" display="menu" />
            </th>
            <th>Action</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-quiz let-ri="rowIndex" let-editing="editing">
          <tr [pEditableRow]="quiz">
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="quiz.name" />
                </ng-template>
                <ng-template pTemplate="output">
                  {{ quiz.name }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="quiz.teacher" />
                </ng-template>
                <ng-template pTemplate="output">
                  {{ quiz.teacherNamesStr }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="quiz.subject" />
                </ng-template>
                <ng-template pTemplate="output">
                  {{ quiz.mappedQuizMode }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="quiz.totalMarks" />
                </ng-template>
                <ng-template pTemplate="output">
                  {{ quiz.totalQuestions }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td>
              <div class="flex align-items-center justify-content-center gap-2">
                <button
                  pButton
                  pRipple
                  type="button"
                  title="Edit Question"
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-text"
                  (click)="EditCourse(quiz.id)"
                ></button>
                <button
                  pButton
                  pRipple
                  type="button"
                  title="View Analytics"
                  icon="pi pi-chart-bar"
                  class="p-button-rounded p-button-text p-button-info"
                  (click)="onViewAnalytics(quiz.id)"
                ></button>
                <button
                  pButton
                  pRipple
                  type="button"
                  icon="pi pi-trash"
                  [title]="
                    quiz.isPublish ? 'Cannot delete - quiz is already published' : 'Delete Quiz'
                  "
                  (click)="onRowdelete($event, quiz)"
                  [disabled]="quiz.isPublish"
                  [class]="
                    quiz.isPublish
                      ? 'p-button-rounded p-button-text'
                      : 'p-button-rounded p-button-text p-button-danger'
                  "
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5">No data found.</td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>

    <ng-template #studentView>
      <div class="page-wrapper">
        <div class="grid">
          <div class="col-12">
            <div
              class="flex font-bold shadow-2 text-blue-600 text-left text-lg p-1 border-round mb-1 mt-1"
            >
              <div class="col-6 mt-1">
                Quiz List
                <span class="text-sm text-blue-800 p-2 border-round ml-2"
                  >Total: {{ filteredQuizDetails.length }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="card card_gap">
          <p-dataView
            [value]="filteredQuizDetails"
            [layout]="'grid'"
            [rows]="15"
            id="courses"
            [paginator]="true"
          >
            <ng-template pTemplate="header">
              <div class="grid grid-nogutter">
                <div class="col-12 md:col-6 mb-2">
                  <span class="p-input-icon-left w-full">
                    <i class="pi pi-search"></i>
                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="globalSearchQuery"
                      (input)="onFilterChange()"
                      placeholder="Search"
                      class="p-inputtext w-full"
                    />
                  </span>
                </div>
                <div class="col-12 md:col-6 text-right">
                  <p-dropdown
                    [options]="sortOptions"
                    [(ngModel)]="selectedSort"
                    (onChange)="onFilterChange()"
                    placeholder="Sort By"
                    styleClass="mr-2"
                  >
                  </p-dropdown>
                </div>
              </div>
            </ng-template>
            <ng-template pTemplate="grid" let-quizsData>
              <div
                id="grid-layout"
                class="grid grid-nogutter"
                [style.column-gap]="columnGap + '1rem'"
              >
                <div
                  id="card-layout"
                  class="col-12 sm:col-6 md:col-4 xl:col-3 ind-card"
                  *ngFor="let quiz of quizsData; let i = index"
                >
                  <div
                    #myCard
                    class="border-1 surface-border surface-card border-round flex justify-content-between align-items-center mat-elevation-z10"
                  >
                    <div class="flex flex-column">
                      <h3>{{ quiz.name }}</h3>
                      <div class="flex gap-2 mt-1">
                        <div>
                          <i class="pi pi-book" style="font-size: 1rem"></i>
                          {{ quiz.totalMarks }} Marks
                        </div>
                        |
                        <div>
                          {{ quiz.mappedQuizMode }}
                        </div>
                        |
                        <div>
                          <i class="pi pi-clock" style="font-size: 1rem"></i> {{ quiz.time }} Mins
                        </div>
                        |
                        <div>Questions: {{ quiz.totalQuestions }}</div>
                      </div>
                    </div>
                    <div class="flex gap-2 align-items-center">
                      <div class="text-center p-1 border-round-sm">
                        <p-button
                          [label]="getQuizButtonLabel(quiz)"
                          [outlined]="true"
                          [severity]="getQuizButtonSeverity(quiz)"
                          (click)="onTakeQuiz(quiz)"
                          [disabled]="isQuizDisabled(quiz)"
                          pTooltip="{{ getQuizButtonTooltip(quiz) }}"
                          tooltipPosition="top"
                        />
                      </div>
                      <div class="text-center p-1 border-round-sm">
                        <div
                          [title]="
                            quiz.isPublish
                              ? 'View Dashboard'
                              : 'Dashboard available only for published quizzes'
                          "
                        >
                          <button
                            pButton
                            pRipple
                            type="button"
                            icon="pi pi-chart-bar"
                            (click)="onViewDashboard(quiz)"
                            [disabled]="
                              !quiz.isPublish ||
                              (isStudent() &&
                                !submittedQuizzes[quiz.id] &&
                                !(quiz.deadlineDate && checkQuizDeadline(quiz.deadlineDate)))
                            "
                            [class]="
                              quiz.isPublish
                                ? 'p-button-rounded p-button-text p-button-info p-button-sm'
                                : 'p-button-rounded p-button-text p-button-sm'
                            "
                          ></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template pTemplate="empty">
              <div class="text-center p-4">
                <p>No quizzes found matching your search criteria.</p>
              </div>
            </ng-template>
          </p-dataView>
        </div>
      </div>
    </ng-template>
  </div>
</div>
<p-confirmDialog />
